<template>
  <div class="upload-image-button">
    <p
      v-if="title"
      class="upload-image-button_title"
    >
      {{ title }}
    </p>
    <div
      class="upload-image-button_content"
      :class="{text:text}"
      @click="handleUploadBtnClick()"
    >
      <div
        v-if="text"
        class="upload-text"
      >
        <i class="icon-photo" />
        <p>{{ $t('新增圖片') }}</p>
      </div>
      <div v-else-if="wsButton">
        <WsButton001
          normal-width
          @click="handleUploadBtnClick()"
        >
          {{ $t('更換照片') }}
        </WsButton001>
      </div>
      <div
        v-else
        class="upload-img"
      >
        <i class="icon-license" />
        <p>{{ uploadText }}</p>
      </div>
      <input
        ref="fileInput"
        :multiple="multiple"
        type="file"
        accept="image/*"
        @change="fileChange()"
      >
    </div>
    <p
      class="upload-image-button_remind-text"
      :class="{error:error}"
    >
      {{ _remindText }}
    </p>
  </div>
</template>
<script>
export default {
  name: "WsUploadImageButton001",
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: [Array, String],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
    wsButton: {
      type: Boolean,
      default: false,
    },
    uploadUrl: {
      type: String,
      default: "",
    },
    remindText: {
      type: String,
      default: "",
    },
    uploadText: {
      type: String,
      default() {
        return this.$t("上傳證照圖片");
      },
    },
    factory: {
      type: String,
    },
  },
  data: () => ({
    isloading: false,
    C_files: [],
    uploadPercentage: 0,
    image: "",
    error: false,
  }),
  computed: {
    _remindText() {
      return this.remindText !== ''
        ? this.$t(this.remindText)
        : `${this.$t('檔案大小限制')} ≤ 30 MB`;
    }
  },
  watch: {
    C_files: {
      handler() {
        this.$_emitValue();
      },
      deep: true,
    },
    value() {
      this.C_files = this.value;
    },
  },
  mounted() {
    this.$_valueSet();
  },
  methods: {
    handleUploadBtnClick() {
      this.$refs.fileInput.click();
    },
    $_fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async fileChange() {
      const files = this.$refs.fileInput.files;
      //limit:10mb
      const fileLimit = 10 * 1024 * 1024;
      for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
        const file = files[fileIndex];
        if (!file.type.match("image")) {
          this.error = true
          alert(this.$t("檔案規格不正確，請上傳圖片檔案"))
          return
        }
        const base64 = await this.$_fileToBase64(file);
        if (file.size > fileLimit) {
          this.error = true;
          if (!this.remindText) {
            alert(this.$t(`檔案尺寸超過{number}MB`,{number:'10'}));
          }
          return;
        }
        if (this.multiple) {
          let fileData = {
            percent: 0,
            isloading: true,
            previewUrl: base64,
            file: file,
            url: file.name,
            fileIndex: fileIndex,
          };
          this.C_files.push(fileData);
        } else {
          this.C_files = [
            {
              percent: 0,
              isloading: true,
              file: file,
              previewUrl: base64,
              url: file.name,
              fileIndex: fileIndex,
            },
          ];
        }
      }
      const factory = this.factory ? `/factory/${this.factory}` : "";
      this.C_files.forEach((C_file) => {
        if (!C_file.isloading) {
          return;
        }
        const file = C_file.file;
        this.$axios
          .put(`${factory}${this.uploadUrl}${file.name}`, file, {
            onUploadProgress: (progressEvent) =>
              this.$_handleUploadProgress(progressEvent, C_file),
          })
          .then((res) => {
            C_file.url = res.data.signed_url;
            C_file.percent = 0;
            C_file.isloading = false;
            C_file.previewUrl = "";
          });
      }, 0);
    },
    $_valueSet() {
      if (this.value) {
        // this.value.forEach((valueItem) => {
        // this.C_files.push({
        //   url: valueItem,
        // });
        // this.C_files.push({
        //   url: valueItem.url,
        // });
        // });
        this.C_files = this.value;
      }
    },
    $_emitValue() {
      this.$emit("input", this.C_files);
    },
    $_handleUploadProgress(progressEvent, target) {
      target.percent = Math.round(
        (progressEvent.loaded / progressEvent.total) * 100
      );
    },
    deleteImage() {
      this.isloading = false;
      this.image = "";
      let newValue = "";
      this.$emit("input", newValue);
    },
  },
};
</script>